<app-breadcrumb [styleBreadcrumb]="'page-heading'" [title]="'NOTICES'" [breadcrumb]="''" [count]="count"
    icon="fa-alarm-exclamation">
</app-breadcrumb>
<div class="content-background">
    <div class="row">
        <div class="col-sm-12">
            <div class="inputWithIcon inputWithIcon-search float-right d-flex">
                <app-advanced-mode id="noticeGridAdvancedSwitch" [storageKey]="'notices-list'"
                    (collapsibleToggle)="enableAdvanced=$event">
                </app-advanced-mode>
                <input #search kendoTextBox class="ml-4 button-search" placeholder="{{ 'SEARCH-NOTICE' | translate }}"
                    title="{{ 'SEARCH-NOTICE' | translate }}" (keyup)="searchFieldChange(search.value)" />
                <i class="fa fa-search fa-lg fa-fw fa-search-icon"></i>
            </div>
        </div>
    </div>
    <div class="mt-3">
        <kendo-grid [data]="view.gridData" [loading]="view.loading" [navigable]="true"
            [pageable]="count > view.state.take ? { buttonCount: 5, pageSizes: pageSizes} : false"
            [pageSize]="view.state.take" [skip]="view.state.skip" [sortable]="true" [sort]="view.state.sort"
            [filterable]="enableAdvanced" [filter]="view.state.filter" [groupable]="enableAdvanced"
            [group]="view.groups" [selectable]="{ mode: 'single' }" [columnMenu]="enableAdvanced" [resizable]="true"
            [reorderable]="enableAdvanced" (groupChange)="groupChange($event)"
            (dataStateChange)="dataStateChange($event)">
            <kendo-grid-messages noRecords="{{ 'NO-NOTICES' | translate }}">
            </kendo-grid-messages>
            <kendo-grid-column field="text" [width]="30" title="{{ 'NOTICE-TEXT' | translate }}"
                [class]="'grid-column-text'">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <span
                        title="{{dataItem.text && dataItem.text.length > maxTextLength ? dataItem.text : ''}}">{{dataItem.text
                        | truncate: maxTextLength}}
                    </span>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="startOn" [width]="16" title="{{ 'START-DATE' | translate }}" filter="date"
                format="{0:g}" [class]="'grid-column-start-on'">
            </kendo-grid-column>
            <kendo-grid-column field="endOn" [width]="16" title="{{ 'END-DATE' | translate }}" filter="date"
                format="{0:g}" [class]="'grid-column-end-on'">
            </kendo-grid-column>
            <kendo-grid-column field="priorityText" [width]="12" title="{{ 'NOTICE-PRIORITY' | translate }}"
                [class]="'grid-column-priority'">
            </kendo-grid-column>
            <kendo-grid-column class="text-center" field="canDismiss" [width]="10"
                title="{{ 'NOTICE-CAN-DISMISS' | translate }}" filter="boolean" [class]="'grid-column-can-dismiss'">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i *ngIf="dataItem.canDismiss" class="fas fa-check"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column class="text-center" field="active" [width]="10" title="{{ 'ENABLED' | translate }}"
                filter="boolean" [class]="'grid-column-active'">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i *ngIf="dataItem.active" class="fas fa-check"></i>
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedBy" [width]="16" title="{{ 'LAST-MODIFIED-BY' | translate }}"
                [class]="'grid-column-last-modified-by'">
            </kendo-grid-column>
            <kendo-grid-column field="lastModifiedDate" [width]="16" title="{{ 'LAST-MODIFIED-DATE' | translate }}"
                filter="date" format="{0:g}" [class]="'grid-column-last-modified-on'">
            </kendo-grid-column>
            <kendo-grid-command-column [width]="10" title="{{ 'ACTIONS' | translate }}" class="text-center">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <i class="fas fa-edit fa-lg" title="{{ 'EDIT' | translate }}" (click)="editHandler(dataItem['id'])">
                    </i>
                    &nbsp;
                    <i class="fas fa-trash-alt fa-lg" title="{{ 'DELETE' | translate }}"
                        (click)="deleteHandler(dataItem['id'])">
                    </i>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
        <button kendoButton [primary]="false" type="button" class="float-right mt-3 mb-3" (click)="addHandler()">
            {{'ADD' | translate}}<i class="far fa-plus"></i>
        </button>
    </div>
</div>

<!--Add/Edit form-->
<app-notice-edit [model]="editDataItem" [isNew]="isNew" (save)="saveChangesHandler($event)"
    (cancelling)="cancelChangesHandler()">
</app-notice-edit>

<!--Delete confirmation-->
<kendo-dialog title="{{ 'PLEASE-CONFIRM' | translate }}" *ngIf="deleteDialogOpened" (close)="close('deleteDialog')"
    [minWidth]="250" [width]="450">
    <p>{{ 'CONFIRM-DELETION' | translate }}</p>
    <span class="k-font-weight-bold">{{selectedNotice.text}}</span>
    <kendo-dialog-actions>
        <button kendoButton (click)="deleteAction(false)">{{ 'NO' | translate }}</button>
        <button appPreventClick kendoButton (click)="deleteAction(true)" [primary]="true">{{ 'YES' | translate
            }}</button>
    </kendo-dialog-actions>
</kendo-dialog>